import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Card, Col, Form, Row, Select, Space } from 'antd';
import configurationStore from 'common/stores/configuration/configuration.store';
import { formatPhoneWithAreaCode } from 'common/helpers/phone.helper';
import { SaveOutlined } from '@ant-design/icons';
import { FormWrapper } from 'common/components/form-wrapper/form-wrapper';
import { eiqVoiceVersionOptions } from 'features/eiq-manage/enums/eiq-voice-version.enum';
import { notification } from 'common/utils/notification';
import configurationService from 'common/services/configuration-service/configuration.service';
import { IUpdateEIQVoiceConfiguration } from 'common/services/configuration-service/configuration.service.types';

export const EIQVoiceConfiguration = observer(() => {
  const [form] = Form.useForm();

  const initData = configurationStore.configuration?.eiqVoiceConfiguration;

  useEffect(() => {
    if (form) {
      form.setFieldsValue(initData);
    }
  }, [form, initData]);

  const onFinish = async (values: any) => {
    const request: IUpdateEIQVoiceConfiguration = {
      EIQVoiceConfiguration: {
        version: values.version,
      },
    };

    const result = await configurationService.updateSystemConfiguration(request);
    configurationStore.setConfiguration(result);
    notification.success({
      message: 'Configurations successfully updated',
      duration: 5,
    });
  };

  return (
    <FormWrapper form={form} onFinish={onFinish} initialValues={initData} layout="vertical" style={{ height: '100%' }}>
      <Card className="eiq-card eiq-card-border eiq-configuration">
        <Row className="eiq-card-header">
          <Col span={24}>
            <h1 className="h1">EIQ-Voice</h1>
          </Col>
        </Row>
        <Row>EIQ-Voice phone number: {formatPhoneWithAreaCode(configurationStore.communitySettings?.eiqVoicePhoneNumber)}</Row>
        <Row>
          <Col xs={24} sm={12}>
            <Space className="full-width" style={{ flexDirection: 'column' }}>
              <Form.Item name="version" label="EIQ Voice version">
                <Select options={eiqVoiceVersionOptions} />
              </Form.Item>
            </Space>
            <Button htmlType="submit" type="primary" icon={<SaveOutlined />} style={{ width: '100%' }}>
              Save
            </Button>
          </Col>
        </Row>
      </Card>
    </FormWrapper>
  );
});
